/**
 * MaintenanceIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const MaintenanceIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M18.947 22.407a2 2 0 0 1-1.41-.58l-6.85-6.85a1.05 1.05 0 0 0-1-.25 6.8 6.8 0 0 1-3 .12 7 7 0 0 1-5-9.9 1 1 0 0 1 .74-.55 1 1 0 0 1 .78.29l3.74 3.72 1.42-1.41-3.73-3.74a1 1 0 0 1-.28-.87 1 1 0 0 1 .54-.7 7 7 0 0 1 9.9 5 6.8 6.8 0 0 1-.12 3c-.095.354 0 .732.25 1l6.85 6.85a2 2 0 0 1 0 2.82l-1.42 1.42a1.94 1.94 0 0 1-1.41.63m1.42-3.41-6.85-6.85a3 3 0 0 1-.77-2.92 4.8 4.8 0 0 0 .08-2.17 5 5 0 0 0-4-4 4.9 4.9 0 0 0-1.62 0l2.57 2.53a2 2 0 0 1 0 2.82l-1.42 1.42a2 2 0 0 1-2.82 0l-2.57-2.57a4.9 4.9 0 0 0 0 1.62 5 5 0 0 0 4 4 4.86 4.86 0 0 0 2.18-.08 3 3 0 0 1 .79-.1 3 3 0 0 1 2.13.87l6.85 6.84z" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const MaintenanceIcon = makeIcon('MaintenanceIcon', MaintenanceIconSvg)
